// extracted by mini-css-extract-plugin
export default {"inputLabel":"InputField_inputLabel__PJHoi","text":"InputField_text__D5Rp7","formInput":"InputField_formInput__vTfRB","asterisk":"InputField_asterisk__kGILD"};